export default __webpack_public_path__ + "static/masthead-vid-2284dcfc67531c5225f54f5011f82bb7.webm";